import { ReactNode, isValidElement } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';

import { GlobalNavEyebrow } from '../../nav-links-container';
type ProductsGridProps = {
	products: ReactNode[];
	title: ReactNode;
	isMobile?: boolean;
};

export const BaseGrid = ({ products, title, isMobile }: ProductsGridProps) => {
	const columns = '1fr 1fr 1fr';

	return (
		<div
			css={css({
				[media.below.md]: {
					marginBlockStart: token('space.150'),
				},
				[media.only.sm]: {
					maxWidth: '328px',
				},
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
				'.base-products-grid-title': {
					margin: 0,
					padding: 0,
					color: wacToken('color.primary.black'),
					fontSize: '14px',
					fontWeight: 400,
					fontFamily:
						"'Charlie Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif",
					lineHeight: '20px',
					[`&.base-products-grid-title-3-max`]: {
						textTransform: 'uppercase',
						fontSize: '0.75rem',
					},
				},
			})}
		>
			{isValidElement(title) ? (
				title
			) : (
				<GlobalNavEyebrow
					removeMargin={true}
					className="base-products-grid-title base-products-grid-title-3-max"
				>
					{title}
				</GlobalNavEyebrow>
			)}

			<ul
				className="base-products-grid base-products-grid-3-max"
				css={css({
					display: 'grid',
					marginInline: 0,
					marginBlockStart: 0,
					marginBlockEnd: token('space.100'),
					listStyle: 'none',
					padding: 0,
					alignItems: 'start',
					gridTemplateColumns: isMobile ? '1fr' : columns,
					columnGap: token('space.400'),
					[`&.base-products-grid-3-max`]: {
						columnGap: '10px',
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
						a: {
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
							[`.logo-container`]: {
								width: token('space.400'),
								height: token('space.400'),
								marginInlineEnd: token('space.100'),
							},
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
							[`.product-description-container`]: {
								gap: token('space.025'),
							},
						},
						[media.below.md]: {
							gridTemplateColumns: '1fr',
						},
					},
				})}
				data-testid="product-grid"
			>
				{products}
			</ul>
		</div>
	);
};
